import { BasicRequest } from "./basicRequest";

export class PublishTransformationDefinitionRequest extends BasicRequest{
    public transformationDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}